// CONTENT.JS
//
// This File contains the contents of the website!
// Changes in this file only take effect, after: npm run build
//
// The website content is specified as a javascript object literal below.
// The "content"-fields, below can be an object or an array of objects. Content objects can be nested.
//
// Hint: Use ` ` for multi-line strings. (This is what requires the build step - as it is not supported by all browsers)
//
// Supported Objects in content fields:
//
// // Simple HTML:
// 	{
//		type: "html"
//		value: "<p>some html<p>"
// 	}
// // Expandable: Allows to show/hide content by clicking on title
// 	{
// 		type: "expandable",
// 		title: "The Title",
// 		content: []
// 	}
// // Cards: Allows to display content in cards
// 	{
// 		type: "cards", // use "cards-light" for dark background
// 		cards:
// 		[
// 			{
// 				card: "1",
// 				content: []
// 			},
// 			{
// 				card: "2",
// 				content: []
// 			},
// 		]
// 	}
// // Table:
// 	{
// 		type: "table",
// 		widths: ['4em','auto','auto','auto'], // column widths
// 		// rowStyle: ["font-weight: bold;font-size: 1.2em", "font-weight: bold; background-color: #2B628D; color: white","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;"],
// 		// colStyle: ["font-weight: bold"],
// 		// cellStyle: "",

// 		// rowClass: [],
// 		// colClass: [],
// 		// cellClass: "",

// 		table: [
// 			["cell11","cell12","cell13","cell14"], // row 1
// 			["cell21","cell22","cell23","cell24"], // row 2
// 		]
// }
// Components:
// 	{
// 		type: "component:co-sponsors" / "component:sponsors" / "component:speakers" / "component:organizers"
// 	}

// Styles AND Classes:
// Except for Components (i.e., type: "component:..."). All content objects support fields "class" & "style" to add specific classes and styles to the contents.

// Timing:
// Every content object or property (simple properties can be made objects as {value: string})
// can have "from" and / or "till" properties that specify when they are to be displayed.
// If there are multiple choices depending on the date. Arrays of {value: x, from:y, till:z} are possible. The first match will be displayed.
// Time Format is: 2020-09-29T14:23:00 // all time must be specified in CEST = UTC+2
// Examples:
// header:{
//	 message: [{value: "Register Now", till:"2020-09-29T08:00"},{value: "Ongoing",from:"2020-09-29T08:00"}]
// }
//

// Icons: https://fontawesome.com/v5.3.1/icons?d=gallery

export var content = {
	copyrightText: "Copyright © IEEE Princeton Central Jersey Section 2015 - ",
	menu: [
		{ text: "Home", target: "page-top" },
		{ text: "Venue", target: "venue" },
		{ text: "Partners", target: "partners" },
		{ text: "Speakers", target: "speakers" },
		{ text: "Registration", target: "registration" },
		{ text: "Agenda", target: "agenda" },
		{ text: "Exhibition", target: "exhibition" },
		{ text: "Committee", target: "committee" },
	],
	header: {
		title:
			'<img alt="7th IEEE 5G++ Summit Dresden" src="img/heading_website.svg" class="tooltiptextself" style="height:2.5em; margin-bottom: 0em; max-width:100%">',
		dates: "May 12, 2022 in Dresden, Germany",
		message: "Join Us on the Road to 6G",
		buttons: [
			{
				text: "Follow Us",
				icon: "fab fa-twitter", // FA Icon
				target: "https://twitter.com/5g_lab",
			},
			// {
			// 	text: "Add to Calendar",
			// 	icon: "far fa-calendar-alt",
			// 	target: "5gsummit-dresden-2022.ics",
			// },
			// {
			// 	text: "Agenda",
			// 	icon: "fa fa-file-pdf",
			// 	target: "Agenda.pdf",
			// },
			{
				text: "Impressions",
				icon: "fa fa-image",
				target: "https://5glab.de/impressions-of-ieee-5g-summit-dresden-2022/",
			},
			// {
			// 	text: "Register Now",
			// 	icon: "fa fa-pen-nib",
			// 	target: "#registration"
			// },
			// {
			// 	text: "Web App",
			// 	icon: "fa fa-external-link-alt",
			// 	target: "https://whova.com/portal/webapp/gsumm_202105/"
			// },
			// {
			// 	text: "Revisit 2020 Summit",
			// 	icon: "fa fa-redo",
			// 	target: "/dresden-2020"
			// },

			// {
			// 	text: "Register Now",
			// 	//icon: "play", // FA Icon
			// 	target: "registration",
			// 	till: "2020-10-08T23:30:00"
			// },
			// {
			// 	text: "Stay Tuned",
			// 	icon: "twitter", // FA Icon
			// 	target: "https://twitter.com/5g_lab"
			// }
		],
	},
	sections: [
		{
			name: "about",
			background: "light",
			content: [
				{
					type: "html",
					value: `
					<p style="font-weight: bold; font-size: 1.9em">Thank you for your participation!</p>
					<p style="font-size: 1.6em; margin-bottom: 2em;">Impressions from the event are available <a href="https://5glab.de/impressions-of-ieee-5g-summit-dresden-2022/">&gt;&gt;here&lt;&lt;</a>.</p>
					`,
				},
				{
					type: "html",
					value: `
					<p>IEEE 5G++ Summit Dresden has become a prominent annual fixture on the road to 6G. The well-known high-impact conference brings together industry leaders, innovators, and researchers from industry and academia to exchange ideas that will help to drive standards and rapid deployment of 5G++ technologies. The IEEE 5G++ Summit Dresden takes a holistic approach to 5G++ system design, ranging from silicon hardware, wireless interfaces, networks, edge clouds all the way up to Tactile Internet applications.</p>
					<p>Over the past 6 years, we have had great success with four physical events at the Dresden Congress Center and two virtual events in 2020 and 2021, due to the global travel restrictions. For 2022, <strong>we are returning to our tried and true format as a physical event</strong>, with the option of limited virtual participation. The summit and exhibition will take place on <strong>May 12, 2022 at our new venue, <a href="#venue">Messe Dresden</a></strong>. </p>
					<p>We very much look forward to your participation!</p>
					`,

					//<h3 style="margin-top: 4em; margin-bottom: 0.5em;">Check Out Last Year's Online Event</h3>
					//<p>You can still register and rewatch the full event at <a href="http://5gsummit.org/dresden-2020/">5gsummit.org/dresden-2020</a>.</p>
				},

				{
					type: "html",
					value: `
					<cosponsors></cosponsors>
					`,
				},
			],
		},
		{
			name: "venue",
			title: "Venue",
			background: "venue",
			content: [
				{
					type: "html",
					value: `
					<p><strong>Location:</strong> <a href="https://www.google.com/maps/place/Messering+7,+01067+Dresden/" target="_blank">Messe Dresden</a> </p>
					<p><strong>Accommodation:</strong> <a href="https://www.hrs.de/list?location=%25765608&orderBy=Recommendations&startDateDay=11&startDateMonth=5&startDateYear=2022&endDateDay=13&endDateMonth=5&endDateYear=2022&lang=de&currency=EUR&adults=1&singleRooms=1&intcmp=btcweb" target="_blank">Book a Hotel</a></p>
					<div style="margin-top:2em; width: 100%; display: flex; justify-content: center;"><div style="border: 1px solid white; max-width: 95%; overflow-x: auto;"><img alt="Venue Plan" src="venue_plan.svg" width="800px"></div></div>
					`,
					//<h3 style="margin-top: 2em">Virtual Event App</h3>
					//<div class="container"><div style="margin-bottom: 0em;"><div class="container"><p style="margin-top: 0em;">Registered accounts will receive access information on May 11, 2022. <br> Create an account and join the event on your browser:</p></div></div> <div style="margin-bottom: 2em;"><a href="https://hopin.com/events/7th-ieee-5g-summit-dresden" class="btn btn-outline" style="padding: 15px 25px;">Go to the Web App</a></div> <div style="margin-bottom: 2em;"><b> Or join with the Hopin smartphone app</b></div> <div style="margin: 10px auto; width: 360px;"><div style="text-align: center; float: left; margin: 0px auto; width: 180px;"><a id="app-badge" href="https://apps.apple.com/us/app/hopin/id1542021364" onclick="track_download_click('ios');ems_tracking('portal_download_ios');" target="_blank"><img src="https://whova.com/static/tab/img/badge_ios.png"></a></div> <div style="text-align: center; float: left; margin: 0px auto; width: 180px;"><a id="android-badge" href="https://play.google.com/store/apps/details?id=to.hopin.android&hl=en_US&gl=US" onclick="track_download_click('android');ems_tracking('portal_download_android');" target="_blank"><img src="https://whova.com/static/tab/img/badge_android.png"></a></div></div></div>
				},
			],
		},
		{
			name: "partners",
			title: "Partners",
			content: [
				{
					type: "html",
					value: `
						<sponsors json="data/sponsors.json" pictures="data/sponsors/" :exclude="['Exhibitors']"></sponsors>

						<p>Interested in becoming a patron? Check out our <a href="2022_Patronage_Brochure.pdf">Patronage Brochure <i class="fa fa-file-pdf"></i></a> .</p>
						<p>To arrange your individual patronage package, please contact <a href="mailto:carolin.bauder@tu-dresden.de">Carolin Bauder</a>.</p>
					`,
				},
			],
		},
		{
			name: "speakers",
			title: "Speakers",
			background: "dark",
			content: [
				{
					type: "component:speakers",
				},
			],
		},

		{
			name: "registration",
			title: "Registration",
			content: [
				// <p><p style="margin-top: -0em; font-size: 1.5em;">Registration is now available. Please register <a style="font-weight: bold" href="https://react.regasus.de/portal/init?mnemonic=5GSummit2022" target="_blank">&gt;&gt;&nbsp;here&nbsp;&lt;&lt;</a>&nbsp;.</p></p>
				{
					type: "html",
					value: `
					<p style="margin-top: -0em; font-size: 1.5em;">Registration closed!</p>
					`,
				},

				{
					type: "html",
					value: `
					<h3 style="margin-top: 0em">Physical Attendance</h3>

					<label class="check-label" style="margin-top: 0; font-size: 1.3em; cursor: pointer;"><input type="checkbox" v-model="l.includeVat">Include VAT in prices</label>
					<div style="margin-bottom: -1em"></div>
					`,
				},
				{
					type: "table",
					widths: ["12em", "auto", "auto", "auto"],
					rowStyle: ["font-weight: bold; border-bottom: 1px solid gray; background-color: #c1b9c9"],
					colStyle: ["font-weight: bold;"],
					cellStyle: "font-size: 1.2em;",

					// 		// rowClass: [],
					// 		// colClass: [],
					// 		// cellClass: "",
					table: [
						[``, "Standard", "Late", "Last Minute / On-Site"],
						["Regular *", "{{getPrice(400)}} €", "{{getPrice(450)}} €", "{{getPrice(480)}} €"],
						["IEEE Member *", "{{getPrice(350)}} €", "{{getPrice(400)}} €", "{{getPrice(430)}} €"],
						[
							"IEEE ComSoc Member *",
							"{{getPrice(300)}} €",
							"{{getPrice(350)}} €",
							"{{getPrice(380)}} €",
						],
						["Student *", "{{getPrice(150)}} €", "{{getPrice(170)}} €", "{{getPrice(200)}} €"],
						[
							"Networking Only **",
							"{{getPrice(80)}} €",
							"{{getPrice(100)}} €",
							"{{getPrice(130)}} €",
						],
					],
				},
				{
					type: "html",
					value: `


					<div style="font-size: 0.9em">
						<p style="margin-top: -1em">Prices <span v-show="!l.includeVat">excluding 19% VAT that apply additionally</span><span v-show="l.includeVat">including 19% VAT</span>.</p>
						<p>* Includes participation in the physical conference part at Messe Dresden on May 12, coffee break/lunch catering and participation in the conference dinner on May 12. Also includes: all benefits of the virtual attendance registration.</p>
						<p>** Participation in the conference dinner on May 12.
						</div>
					`,
				},
				{
					type: "html",
					value: `


					<h4 style="margin-top:1em; font-size: 1.3em;">Online Registration Deadlines</h4>
					<ul style="font-size: 1.3em; line-height: 1.8;">
					<li><strong>Standard:</strong> April 13, 2022, 23:59 CEST</li>
					<li><strong>Late:</strong> May 4, 2022, 23:59 CEST</li>
					<li><strong>Last Minute:</strong> May 10, 2022, 23:59 CEST</li>
					</ul>
					`,
				},
				{
					type: "html",
					value: `
					<h3 style="margin-top: 1.5em">Virtual Attendance</h3>
					<label class="check-label" style="font-size: 1.3em; cursor: pointer;"><input type="checkbox" v-model="l.includeVat">Include VAT in prices</label>
					<div style="margin-bottom: -1em"></div>
					`,
				},
				{
					type: "table",
					widths: ["12em", "15em"],
					rowStyle: ["font-weight: bold; border-bottom: 1px solid gray; background-color: #c1b9c9"],
					colStyle: ["font-weight: bold;"],
					cellStyle: "font-size: 1.2em;",

					// 		// rowClass: [],
					// 		// colClass: [],
					// 		// cellClass: "",
					table: [
						[``, "Standard"],
						["Regular", "{{getPrice(100)}} €"],
						["IEEE Member", "{{getPrice(80)}} €"],
						["IEEE ComSoc Member", "{{getPrice(60)}} €"],
						["Student", "{{getPrice(40)}} €"],
					],
				},
				{
					type: "html",
					value: `
					<div style="font-size: 0.9em">
						<p style="margin-top: -1em;">Prices <span v-show="!l.includeVat">excluding 19% VAT that apply additionally</span><span v-show="l.includeVat">including 19% VAT</span>.</p>
						<p>Virtual attendees will be able to live-stream selected agenda items, chat with other virtual attendees, view recordings of the live-streams after the event and access the virtual exhibition.</p>
					</div>

					`,
				},
				// value: `
				// <div style="margin-bottom: 2em;"><div class="container"><p style="margin-top: 0em; font-size: 1.5em;">Registration is now available. Please register <a href="https://kitd.regasus.de/online/index?webid=IEEE5G2021" target="_blank" style="font-weight: bold;">&gt;&gt;&nbsp;here&nbsp;&lt;&lt;</a>&nbsp;.</p> <h3 style="margin-top: 2em;">Registration Fees:	</h3> <div style="margin-bottom: -2em;"></div></div></div>

				// <div style="margin-bottom: 2em;"><div class="container">
				// <div class="tbl container">
				// <div class="rw" style="font-weight: bold; color: #ffffff; border-bottom: 1px solid gray; background-color: rgb(43, 98, 141);"><div class="cl" style="flex: 0 0 auto; width: 10em; font-weight: bold; font-size: 1.2em;"><div></div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// <div>Non IEEE Member</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// <div>IEEE Member<sup>*</sup></div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// <div>IEEE ComSoc Member<sup>*</sup></div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// <div>IEEE Life Member<sup>*</sup></div></div></div><div class="rw"><div class="cl" style="flex: 0 0 auto; width: 10em; font-weight: bold; font-size: 1.2em;">
				// <div>Full Registration</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>100</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>80</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>60</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>50</span> €</div></div></div><div class="rw"><div class="cl" style="flex: 0 0 auto; width: 10em; font-weight: bold; font-size: 1.2em;">
				// <div>Student Registration</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>50</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>40</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>30</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div>-</div></div></div><div class="rw"><div class="cl" style="flex: 0 0 auto; width: 10em; font-weight: bold; font-size: 1.2em;">
				// <div>Exhibition Visitor<sup>**</sup></div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>0</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>0</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>0</span> €</div></div><div class="cl" style="flex: 0 0 auto; width: calc(((100% - 24px) - 10em) / 4); font-size: 1.2em;">
				// 	<div><span>0</span> €</div></div></div><div class="rw"><div class="cl" style="flex: 0 0 auto; width: 10em; font-weight: bold; font-size: 1.2em;">
				// </div></div></div></div></div>

				// <div style="margin-bottom: 2em;"><div class="container"><p>Prices <span style="">excluding 19% VAT that apply additionally</span><span style="display: none;">including 19% VAT</span>.</p> <p><sup>*</sup> Member benefits can only be granted for registrations before May 3, 2021 23:59pm CEST.</p> <p><sup>**</sup>The number of Exhibition Visitor tickets is limited to 1000.</p></div></div>
				// <div style="font-size: 20px;">

				//     <h4 style="margin-top: 30px;">Full Registrations and Student Registrations include:</h4>
				//     <li style="font-size: 20px;">Access to all conference sessions on May 5</li>
				//     <li>Access to the virtual exhibition area on May 4, May 5 and May 6</li>

				//     <h4 style="margin-top: 30px;">Registration as an Exhibiton Visitor grants:</h4>
				//     <li>Access to the virtual exhibition on May 4 and May 6</li>
				// <p></p>
				// </div>
				// `
			],
		},
		{
			name: "agenda",
			title: "Agenda",
			background: "dark",
			content: [
				{
					type: "html",
					value: `
					<div style="width: 100%; display: flex; justify-content: center;"><div style="border: 1px solid white; max-width: 95%; overflow-x: auto;"><img alt="Agenda" src="Agenda.svg" width="800px"></div></div>
					`,
				},
			],
		},
		{
			name: "exhibition",
			title: "Exhibition",
			// background: "dark",
			content: [
				{
					type: "html",
					value: `
						<div style="width: 100%; display: flex; justify-content: center;"><div style="border: 1px solid white; max-width: 95%; overflow-x: auto;"><img alt="Exhibition Plan" src="exhibition_plan.svg" width="600px"></div></div>
						<p>Interested in becoming an exhibitor at our event? Check out our <a href="2022_Patronage_Brochure.pdf">Patronage Brochure <i class="fa fa-file-pdf"></i></a> .</p>
						<p>Please contact <a href="mailto:carolin.bauder@tu-dresden.de">Carolin Bauder</a> for further information.</p>
						<sponsors :headings="true" json="data/sponsors.json" pictures="data/sponsors/" :include="['Exhibitors']"></sponsors>
					`,
				},
			],
		},

		{
			name: "committee",
			title: "Committee",
			background: "dark",
			content: [
				{
					type: "component:organizers",
				},
			],
		},
	],
};
